var map = {
	"./giftcard_details_failed.svg": "0497",
	"./investment_details_failed.svg": "d9c7",
	"./mkt_details_failed.svg": "a08a",
	"./payment_details_failed.svg": "c804",
	"./topup_details_failed.svg": "6bcd",
	"./voucher_details_failed.svg": "c7d6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "82ae";